const enum OTPType {
  Email = 1,
  SMS = 2,
}

const enum PopupType {
  Appointment = 1,
  ATECase = 2,
  MaintenanceRequest = 3,
}

const enum showHistoricalDataChangeSource {
  Appointment = 1,
  ATECase = 2,
  MaintenanceRequest = 3,
  Invoice = 4,
  ConsolidatedInvoice = 5,
}

enum RoutePaths {
  Home = "/",
  Register = "/bmc-registration",
  Profile = "/my-profile",
  CDProfile = "/my-profile",
  Login = "/bmc-login",
  ForgetPassword = "/forget-password",
  ChangePassword = "/change-password",
  Dashboard = "/my-dashboard",
  CDDashboard = "/my-dashboard",
  PreventiveAppointment = "/preventive-appointments",
  MaintenanceRequests = "/maintenance-requests",
  ATECases = "/system-faults",
  AllCases = "/maintenance-faults",
  AssignedBuildings = "/manage-properties",
  SearchForBuilding = "/manage-properties/assign-new-property",
  ViewInvoices = "/view-invoices",
  ViewConsolidatedInvoiceDetails = "/view-invoices/consolidated-invoice-details",
  BuildingDetails = "/manage-properties/property-details",
  BuildingContract = "/manage-properties/property-contract",
  BuildingSystems = "/manage-properties/property-systems",
  BuildingConsent = "/manage-properties/property-consent",
  AssignedBuildingDetails = "/manage-properties/assigned-property-details",
  PayInvoice = "/manage-properties/invoice",
  Payment = "/payment",
  Survey = "/manage-properties/add-property-survey",
  PaymentSuccess = "/payment-success",
  PaymentFail = "/payment-fail",
  BreachedCases = "/breached-maintenance-faults",
  BreachedPreventiveAppointments = "/breached-preventive-appointments",
  BMCWithRating = "/companies-rating",
  SendRequestToBMC = "/send-request-to-bmc",
  AboutUs = "/about-us",
  PrivacyPolicy = "/privacy-policy",
  TermsAndConditions = "/terms-and-conditions",
}
enum Languages {
  English = "en",
  Arabic = "ar",
}
enum SLABreachedStatuses {
  Exceeded = "Exceeded",
  OnTrack = "On Track",
}
enum SLABreachedStatusesAr {
  Exceeded = "تجاوز",
  OnTrack = "ضمن الإطار الزمني",
}
enum Statuses {
  Open = "Open",
  WaitingForDetails = "Waiting for Details",
  InProgress = "In Progress",
  OnHold = "On Hold",
  Researching = "Researching",
  InformationProvided = "Information Provided",
  ProblemSolved = "Problem Solved",
  SnagRectified = "Snag Rectified",
  NoAnswer = "No Answer",
  DuplicateCase = "Duplicate Case",
  QA = "QA",
  ReQA = "ReQA",
  Refund = "Refund",
  ChangeOfOwnership = "Change of ownership",
  Merged = "Merged",
  Canceled = "Canceled",
  New = "New",
  Inactive = "Inactive",
  Completed = "Completed",
  NotPaid = "Not-Paid",
  RedirectedToPGW = "Redirected To PGW",
  Exceeded = "Exceeded",
  Pending = "Pending",
}
enum DownloadViewPrefixes {
  MaintenanceRequests = "MaintenanceRequests",
  PreventiveAppointments = "PreventiveAppointments",
  BreachedPreventiveAppointments = "BreachedPreventiveAppointments",
  ATECases = "SystemFaults",
  AllCases = "MaintenanceFaults",
  AssignedBuildings = "ManageProperties",
  BreachedCases = "BreachedMaintenanceFaults",
  BMCWithRatings = "CompaniesRating",
}

enum ContractStatuses {
  Active = 0,
  Inactive = 1,
}
enum ConsolidatedInvoiceStatuses {
  PaymentCompleted = "Payment Completed",
  RedirectedToPGW = "Redirected To PGW",
  NotPaid = "Not Paid",
}
enum ConsolidatedInvoiceStatusesInNumbers {
  NotPaid = 1,
  RedirectedToPGW = 2,
  PaymentCompleted = 3,
}

export enum InvoiceStatuses {
  PaymentCompleted = "Payment Completed",
  RedirectedToPGW = "Redirected To PGW",
  NotPaid = "Not-Paid",
  Refunded = "Refunded",
  Cancelled = "Cancelled",
}
export enum InvoiceStatusesInNumbers {
  NotPaid = 0,
  RedirectedToPGW = 1,
  PaymentCompleted = 2,
  Refunded = 3,
  Cancelled = 4,
}
export enum PaymentInitiator {
  AssignedBuilding = "AssignedBuilding",
  Invoice = "Invoice",
}

export enum StatusesColors {
  Completed = "#155724",
  InProgress = "#F6CC0D",
  Exceeded = "#FF7E86",
  Pending = "#eb7e0a",
  OnHold = "#A9A9A9",
  Planck = "#F4F5F9",
  Active = "#2196F3",
  Expiringin30Days = "#FF7E86",
  Expiringin90Days = "#F6CC0D",
  Excellent = "#43BF81",
  Good = "#94D82D",
  Fair = "#F6CC0D",
  Poor = "#FF7E86",
  OpenAndExceeding = "#F79E1B",
}

export enum BMCsWithRatingStatuses {
  Outstanding = 0,
  Cleared = 2,
}
export enum BMCRatings {
  Poor = "Poor",
  Fair = "Fair",
  Good = "Good",
  Excellent = "Excellent",
}
export const StatusesWithHoldReason = {
  PendingOwnerApproval: "pending owner approval",
};

export enum UnassignableBuildingStatuses {
  Rejected = "Rejected",
  Completed = "Completed",
}
export enum UnassignOptions {
  Building = "Building",
  System = "System",
}
export enum PreventedAppointmentStatusesByUser {
  Inactive = "inactive",
  Unassigned = "unassigned",
}

export {
  OTPType,
  PopupType,
  showHistoricalDataChangeSource,
  RoutePaths,
  Languages,
  SLABreachedStatuses,
  Statuses,
  SLABreachedStatusesAr,
  DownloadViewPrefixes,
  ContractStatuses,
  ConsolidatedInvoiceStatuses,
  ConsolidatedInvoiceStatusesInNumbers,
};
